<template>
    <div class="input-field custom-date-picker" :class="classes">
        <el-row :gutter="10">
            <el-col
                :span="type === HORIZONTAL ? spanLabel : 24"
                :xl="type === HORIZONTAL ? spanLabel : 24"
                :md="type === HORIZONTAL ? spanLabel : 24"
                :sm="24"
                :xs="24"
                :class="type !== HORIZONTAL ? 'col-vertical' : ''"
                class="col-label my-1 my-sm-0"
            >
                <div :class="type === HORIZONTAL ? 'form-label input-field__label--hor' : 'form-label input-field__label--ver'">
                    <slot name="label"></slot>
                    {{ labelText }}
                    <span v-if="isRequired" class="text-danger ml-1">*</span>
                </div>
                <div v-if="$slots.sublabel" class="input-field__sublabel">
                    <slot name="sublabel"></slot>
                </div>
            </el-col>
            <el-col :span="type === HORIZONTAL ? spanInput : 24" :xl="type === HORIZONTAL ? spanInput : 24" :md="type === HORIZONTAL ? spanInput : 24" :sm="24" :xs="24">
                <div :class="{ 'input-field__input--error': $slots.error }">
                    <slot></slot>
                </div>
                <transition name="fade">
                    <div class="invalid-feedback error-show-common d-block" v-if="$slots.error">
                        <slot name="error"></slot>
                        <el-icon class="el-icon-warning"></el-icon>
                    </div>
                </transition>
            </el-col>
        </el-row>
    </div>
</template>

<script>
// Component create row input
import { HORIZONTAL, TYPE_LINK } from '@/config/constants';

export default {
    name: 'inputField',
    props: {
        sub: {
            type: Boolean,
            required: false
        },
        type: {
            type: String,
            default() {
                return HORIZONTAL;
            }
        },
        spanLabel: {
            default() {
                return 4;
            },
            required: false
        },
        spanInput: {
            default() {
                return 20;
            },
            required: false
        },
        classes: {
            type: String,
            required: false,
            default: ''
        },
        isRequired: {
            type: Boolean,
            default: false
        },
        labelText: {
            required: false,
            default: ''
        }
    },
    components: {},
    data: function () {
        return {
            HORIZONTAL,
            TYPE_LINK
        };
    },
    methods: {
        openLink(link) {
            window.open(link, '_blank');
        }
    }
};
</script>

<style lang="scss">
.col-label {
    min-height: 40.2px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-right: 12px;
    font-weight: 500;
    @include Responsive(XS) {
        min-height: 10px;
        justify-content: flex-start;
        width: fit-content;
        margin-bottom: 0px !important;
    }
}

.input-field {
    .col-label {
        @include Responsive(XS) {
            margin-bottom: 0px !important;
        }
    }
    .form-control {
        &.is-invalid {
            background-color: rgba(248, 189, 189, 0.7);
        }
    }
    .invalid-feedback {
        background-color: #fedede;
        padding: 2px 5px;
        border-radius: 5px;
        position: relative;
        width: fit-content;
        i {
            margin-left: 3px;
        }
        &:before {
            position: absolute;
            display: inline-block;
            border-right: 5px solid transparent;
            border-bottom: 5px solid #fedede;
            border-left: 5px solid transparent;
            content: '';
            top: -4px;
            left: 15px;
        }
        i {
            margin-top: 2px;
        }
    }
    .text-error {
        color: #fa5151;
        line-height: 1.5;
        padding: 4px 5px;
        background-color: #fedede;
        border-radius: 5px;
    }
    &__label {
        &--hor {
            @include Responsive(MD) {
                font-size: 14px;
            }
            @include Responsive(XS) {
                font-size: 14px;
            }
        }
        &--ver {
            text-align: left !important;
            width: 100%;
            font-weight: 500;
            @include Responsive(XS) {
                margin-left: 0px;
            }
        }
    }
    &__input {
        &--error {
            input[type='text'],
            input[type='number'],
            input[type='password'],
            textarea,
            input,
            .bg-check-group {
                background: #fedede !important;
                border: 1px solid #fa5151;
                box-sizing: border-box;
                //background-image: none !important;
            }
            .el-upload {
                border-color: rgba(229, 0, 0, 0.7) !important;
                border-width: 2px !important;
            }
            .el-input-group--append .el-input__inner,
            .el-input-group__prepend {
                border-radius: 8px 0px 0px 8px !important;
            }
        }
    }
}
</style>
